import { useState, useRef, useEffect } from 'react';
import Tooltip from '@mui/material/Tooltip';

const ScrollAwareTooltip = ({ children, title, onOpen, onClose, open: propOpen, ...props }) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const anchorRef = useRef(null);
  const mousePositionRef = useRef({ x: 0, y: 0 });

  // Determine if component is controlled
  const isControlled = propOpen !== undefined;
  const open = isControlled ? propOpen : internalOpen;

  useEffect(() => {
    if (!open) return;

    const handleMouseMove = (event) => {
      mousePositionRef.current = { x: event.clientX, y: event.clientY };
    };

    const handleScroll = () => {
      if (!anchorRef.current) return;

      const elements = document.elementsFromPoint(
        mousePositionRef.current.x,
        mousePositionRef.current.y
      );

      const isCursorOverAnchor = elements.some(el => 
        anchorRef.current.contains(el)
      );

      if (!isCursorOverAnchor) {
        if (isControlled) {
          onClose?.();
        } else {
          setInternalOpen(false);
        }
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll, true);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [open, isControlled, onClose]);

  const handleTooltipOpen = (event) => {
    if (!isControlled) {
      setInternalOpen(true);
    }
    onOpen?.(event);
  };

  const handleTooltipClose = (event) => {
    if (!isControlled) {
      setInternalOpen(false);
    }
    onClose?.(event);
  };

  return (
    <Tooltip
      {...props}
      title={title}
      open={open}
      onOpen={handleTooltipOpen}
      onClose={handleTooltipClose}
    >
      <div ref={anchorRef}>
        {children}
      </div>
    </Tooltip>
  );
};

export default ScrollAwareTooltip;